/** The TeleHeadache questionnaire's form-set id (headache-questionnaire module). */
export const TH_QUESTIONNAIRE_ID = "B9B57710-833C-42EC-B1F1-DCD4D66C4933";
